// src/views/InitialPayment.jsx
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const InitialPayment = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { customer, cart, subtotal, envio, total, orderId } = location.state || {};

  const [paymentMethod, setPaymentMethod] = useState("");
  const [comprobante, setComprobante] = useState(null);

  if (!customer) {
    // Si no hay datos, redirige al carrito
    navigate("/");
    return null;
  }

  const handleFileChange = (e) => {
    setComprobante(e.target.files[0]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!paymentMethod || !comprobante) {
      alert("Seleccione método de pago y suba el comprobante.");
      return;
    }

    // Aquí enviarías datos al backend (pedidoId, método, archivo)
    console.log({
      orderId,
      paymentMethod,
      comprobante,
    });

    // Redirigir a confirmación de pago / estado completado
    navigate("/recogida-producto", {
    state: {
        customer,
        cart,
        subtotal,
        envio,
        total,
        orderId,
        pickupCode: "ABC123", // o generado desde backend
    },
    });
  };

  return (
    <div
      className="relative flex size-full min-h-screen flex-col bg-white overflow-x-hidden"
      style={{ fontFamily: '"Plus Jakarta Sans", "Noto Sans", sans-serif' }}
    >
      <div className="layout-container flex h-full grow flex-col">
        {/* Encabezado */}
        <header className="flex items-center justify-between whitespace-nowrap border-b border-solid border-b-[#f4f0f0] px-10 py-3">
          <div className="flex items-center gap-4 text-[#181111]">
            <h2 className="text-[#181111] text-lg font-bold">Fashion Store</h2>
          </div>
        </header>

        {/* Contenido */}
        <div className="px-6 md:px-40 flex flex-1 justify-center py-5">
          <form
            onSubmit={handleSubmit}
            className="flex flex-col w-full md:w-[512px] py-5 max-w-[960px] flex-1"
          >
            <div className="flex flex-wrap justify-between gap-3 p-4">
              <p className="text-[#181111] text-[32px] font-bold">
                Pago inicial
              </p>
              <p className="text-gray-600 text-sm">Pedido ID: {orderId}</p>
            </div>

            {/* Método de pago */}
            <h3 className="text-[#181111] text-lg font-bold px-4 pb-2 pt-4">
              Método de pago
            </h3>
            <div className="flex flex-wrap gap-3 p-4">
              {["Yape", "Transferencia"].map((method) => (
                <label
                  key={method}
                  className={`cursor-pointer border rounded-lg px-4 h-11 flex items-center ${
                    paymentMethod === method
                      ? "border-2 border-red-600"
                      : "border-[#e5dcdc]"
                  }`}
                >
                  <input
                    type="radio"
                    name="payment"
                    value={method}
                    checked={paymentMethod === method}
                    onChange={(e) => setPaymentMethod(e.target.value)}
                    className="hidden"
                  />
                  {method}
                </label>
              ))}
            </div>

            {/* Subir comprobante */}
            <h3 className="text-[#181111] text-lg font-bold px-4 pb-2 pt-4">
              Subir comprobante
            </h3>
            <div className="px-4 py-3">
              <input
                type="file"
                accept="image/*,.pdf"
                onChange={handleFileChange}
                className="block w-full text-sm text-gray-600 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border file:border-[#e5dcdc] file:text-sm file:bg-gray-100 hover:file:bg-gray-200"
                required
              />
              {comprobante && (
                <p className="text-sm text-gray-500 mt-2">
                  Archivo seleccionado: {comprobante.name}
                </p>
              )}
            </div>

            {/* Resumen del pedido */}
            <h3 className="text-[#181111] text-lg font-bold px-4 pb-2 pt-4">
              Resumen del pedido
            </h3>
            <div className="p-4">
              {cart.map((item) => (
                <div
                  key={item.name}
                  className="flex justify-between py-2 text-sm text-gray-600"
                >
                  <p>
                    {item.quantity} x {item.name}
                  </p>
                  <p>${(item.quantity * item.price).toFixed(2)}</p>
                </div>
              ))}
              <div className="flex justify-between py-2">
                <p className="text-sm text-gray-600">Envío</p>
                <p className="text-sm">${envio.toFixed(2)}</p>
              </div>
              <div className="flex justify-between py-2 font-bold">
                <p className="text-sm">Total</p>
                <p className="text-sm">${total.toFixed(2)}</p>
              </div>
            </div>

            {/* Botón */}
            <div className="flex px-4 py-3">
              <button
                type="submit"
                className="flex flex-1 justify-center items-center rounded-lg h-12 px-5 bg-red-600 text-white font-bold hover:bg-red-700"
              >
                Enviar comprobante
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default InitialPayment;
